import React from 'react'
import { BsTag as Tag } from 'react-icons/bs'
import { AiOutlineThunderbolt } from 'react-icons/ai'
import { useQuery } from '@apollo/client'
import { GET_ORDER_DISCOUNT } from 'components/Orders/OrderQueries'
import { Tooltip } from 'antd'
import styled from '@emotion/styled'

type Props = {
  merchantId: string
  discountCode: string
}

const AppliedDiscount = ({ merchantId, discountCode }: Props) => {
  const { data, loading } = useQuery(GET_ORDER_DISCOUNT, {
    variables: { merchantId, code: discountCode }
  })

  const discount = data?.discounts?.[0]

  if (loading || !discount) {
    return null
  }

  const isReward = !!discount.customer_reward_id

  const discountTag = (
    <StyledAppliedDiscount isReward={isReward}>
      <div className='content'>
        <div className='wrapper'>
          {isReward ? <AiOutlineThunderbolt /> : <Tag />}
          <p className='code'>{discount.code}</p>
          {!!discount.description && (
            <span className='description'>{discount.description}</span>
          )}
        </div>
      </div>
    </StyledAppliedDiscount>
  )

  if (discount.description?.length < 25) {
    return (
      <div className='_py-24' style={{ width: '100%' }}>
        {discountTag}
      </div>
    )
  }

  return (
    <div className='_py-24' style={{ width: '100%' }}>
      <Tooltip placement='bottom' title={discount.description}>
        {discountTag}
      </Tooltip>
    </div>
  )
}

const StyledAppliedDiscount = styled.div<{ isReward?: boolean }>`
  width: 100%;

  .content {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 12px;
    background-color: ${(props) =>
      props.isReward ? '#F38A1933' : '#389e0d1a'};

    .wrapper {
      max-width: 80%;
      white-space: pre;
      padding: 12px;
      display: flex;
      align-items: center;

      svg {
        margin-right: 5px;
        width: 20px;
        height: 20px;
        fill: #59595a;
        flex-shrink: 0;
      }

      .code {
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 0;
        flex-shrink: 0;
        margin-right: 4px;
      }

      .description {
        color: #59595a;
        font-size: 14px;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 0;
      }
    }
  }
`

export default AppliedDiscount
